import { useMemo } from "react";

export const Sparkles = ({ count = 9, className = "" }) => {
  const stars = useMemo(
    () => Array.from({ length: count }, (_, i) => ({
      left: `${8 + ((i * 37) % 84)}%`, top: `${10 + ((i * 53) % 78)}%`,
      size: 6 + ((i * 7) % 12), delay: `${(i * 0.7) % 4}s`, dur: `${2.6 + ((i * 0.9) % 2.4)}s`,
    })),
    [count]
  );
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      <div className="shine-sweep absolute inset-0" />
      {stars.map((s, i) => (
        <span
          key={i} className="sparkle"
          style={{ left: s.left, top: s.top, width: s.size, height: s.size, animationDelay: s.delay, animationDuration: s.dur }}
        />
      ))}
    </div>
  );
};
